module.exports = __webpack_public_path__ + "static/media/web-section-alt.c8c23ab8.svg";